import { api } from '@/core/api';
import qs from 'querystring';

const URL = '/api/rubric';

export const getInitFilters = () => api.get(`${URL}/initfilters`);
export const get = (params) => api.get(URL, { params });
export const remove = (id) => api.delete(`${URL}/${id}`);
export const getById = (id) => api.get(`${URL}/${id}`);
export const getByIdFromAnnouncement = (id, proposalRequestId) =>
  api.get(`${URL}/${id}?proposalRequestId=${proposalRequestId}`);
export const getAnswers = () => api.get(`${URL}/answers`);
export const save = (payload) => api.post(`${URL}`, payload);
export const getSections = () => api.get(`${URL}/sections`);
export const getAnswersTypes = () => api.get(`${URL}/answers-types`);
export const publish = (id) => api.post(`${URL}/${id}/publish`);
export const rollbackToDraft = (id) => api.post(`${URL}/${id}/rollbacktodraft`);
export const exist = (payload) =>
  api.get(
    `${URL}/exist?academicYearId=${payload.academicYear.id}&serviceId=${payload.service.id}&areaId=${payload.area.id}&typeId=${payload.type.id}`
  );
export const getAllBy = (params) =>
  api.get(`${URL}/query`, {
    params,
    paramsSerializer: (params) => qs.stringify(params),
  });

export const getEvaluationTypesByService = (serviceId) =>
  api.get(`${URL}/evaluationtypes/${serviceId}`);
